import { useQuery } from "@tanstack/react-query";
import { getGoogleAdsAccounts } from "../../api/bGoogleAdsApi";

export const useGetGoogleAdsAccounts = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["google-ads-accounts", organisationId],
    queryFn: () => getGoogleAdsAccounts(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};